import React, { useEffect, useState } from 'react';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { dropdownTypes, states } from '../Reports/values/enums';
import creators from '../Reports/state/roster/creators';
import Dropdown from '../Global/Dropdown';

// FOUND IN STUDENT SEARCH
const SelectSchool = ({
  selectedClass,
  rosterSelect,
  schools,
  rosterStatus,
  district
}) => {
  const { t } = useTranslation();

  const isLoading = rosterStatus === states.PENDING || schools?.length < 1;

  const handleRosterChange = data => {
    //if we selected the same school twice in a row, do nothing
    if (selectedClass && selectedClass.id === data.value) {
      return;
    }

    //Transform the selection to fit the object model to match the Miller Control.
    //TODO: use the Miller Control in Assignment Selection -OR- move this transform down to the rosterSelect method.
    let rosterData = JSON.parse(JSON.stringify(data));
    rosterData.ui = data;
    rosterData.id = data.value;

    rosterSelect({
      type: 'school',
      data: rosterData,
    });
  };

  if (schools?.length < 2) {
    return null;
  }

  return (
    <div
      data-testid="aec-select-school"
      className="aec-select-school d-flex flex-column">
      <Dropdown
        placeholder={isLoading ? t('loading') : t('select_school')}
        value={selectedClass?.ui}
        options={schools?.map(school => school.ui)}
        onChange={data => handleRosterChange(data)}
        type={dropdownTypes.PRIMARY}
        isLoading={isLoading}
        entityLabel={isLoading ? t('loading') : district}
        ariaLabel={isLoading ? t('loading') : `${t("select_school")} (${district})`}
      />
    </div>
  );
};

const mapStateToProps = ({ reports }) => {
  const { roster } = reports;

  return {
    schools: roster.data ? roster.data.school : [],
    selectedClass: roster.ui ? roster.ui.selections.school : null,
    rosterStatus: get(roster, 'status.type'),
    district: Array.isArray(roster?.data?.district) && roster.data.district.length > 0 ? roster.data.district[0]?.label : null,
  };
};

const mapDispatchToProps = dispatch => ({
  rosterSelect: selection => dispatch(creators.rosterSelect(selection)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectSchool);
